import domReady from '@wordpress/dom-ready';

const GreenuxFormSettings = {
  formId: '#requested-url-form',
  inputField: '.wrapper-search-autocomplete input.requested-url-field',
  submitField: '.wrapper-search-autocomplete button.requested-url-submit',
  errorHtml: '.wrapper-search-autocomplete .form-error-message',
  url: window.theme.greenuxServiceUrl
    ? window.theme.greenuxServiceUrl.replace(/\/+$/, '')
    : '',
  resultsPageUrl: window.theme.greenuxResultsPageUrl
    ? window.theme.greenuxResultsPageUrl.replace(/\/+$/, '')
    : '',
  greenuxInvalidUrlMessage: window.theme.greenuxInvalidUrlMessage,
  greenuxRequestErrorMessage: window.theme.greenuxRequestErrorMessage,
};

function processUrl(string) {
  if (!string.startsWith('http')) {
    string = 'https://' + string;
  }
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  const domainRegex =
    /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g;
  if (
    url.hostname.length > 253 ||
    url.hostname.indexOf('localhost') !== -1 ||
    !domainRegex.test(url.hostname)
  ) {
    return false;
  }
  let completeUrl = 'https://' + url.hostname;
  if (url.pathname) {
    completeUrl += url.pathname;
  }
  return completeUrl;
}

domReady(() => {
  if (!GreenuxFormSettings.url || !GreenuxFormSettings.resultsPageUrl) {
    return;
  }
  const inputField = document.querySelector(GreenuxFormSettings.inputField);
  if (!inputField) {
    return;
  }
  const submitField = document.querySelector(GreenuxFormSettings.submitField);
  if (!submitField) {
    return;
  }
  const greenuxForm = document.querySelector(GreenuxFormSettings.formId);
  const errorHtml = document.querySelector(GreenuxFormSettings.errorHtml);
  const showLoading = () => {
    submitField.classList.add('is-loading');
    submitField.setAttribute('aria-busy', 'true');
    submitField.disabled = true;
  };
  const hideLoading = () => {
    submitField.classList.remove('is-loading');
    submitField.removeAttribute('aria-busy');
    submitField.disabled = false;
  };
  if (greenuxForm) {
    greenuxForm.addEventListener('submit', (event) => {
      errorHtml.innerText = '';
      showLoading();
      event.preventDefault();
      event.stopPropagation();
      const requestedUrl = processUrl(inputField.value);
      if (!requestedUrl) {
        errorHtml.innerText = GreenuxFormSettings.greenuxInvalidUrlMessage;
        hideLoading();
        return;
      }
      fetch(GreenuxFormSettings.url + '/query?url=' + requestedUrl)
        .then((response) => {
          if (response.status !== 200) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((data) => {
          // Handle the response data here
          if (data && data.run) {
            const resultsPageUrl =
              GreenuxFormSettings.resultsPageUrl + '/' + data.run;
            window.location.href = resultsPageUrl;
          }
        })
        .catch(() => {
          hideLoading();
          errorHtml.innerText = GreenuxFormSettings.greenuxRequestErrorMessage;
        });
    });
  }
});
